// Hair & Beauty Skills organized by subcategories
export const HAIR_BEAUTY_SKILLS_CATEGORIES = [
  {
    name: 'Hair Styling',
    skills: [
      'Hair Cutting', 'Hair Coloring', 'Hair Highlighting',
      'Balayage Techniques', 'Hair Extensions', 'Blow Drying',
      'Updos & Styling', 'Men\'s Grooming', 'Children\'s Haircuts',
      'Wedding Hair Styling', 'Hair Texturing', 'Hair Straightening',
      'Permanent Waving', 'Hair Braiding', 'Hair Relaxing',
      'Color Correction', 'Scalp Treatments', 'Hair Treatments',
      'Toner Application', 'Root Touch-ups', 'Foil Techniques',
      'Hair Consultation', 'Style Finishing', 'Hair Analysis',
      'Product Knowledge'
    ]
  },
  {
    name: 'Skincare',
    skills: [
      'Facial Treatments', 'Skin Analysis', 'Skin Cleansing',
      'Exfoliation', 'Face Masks', 'Facial Massage',
      'Anti-aging Treatments', 'Acne Treatments', 'Skin Peels',
      'Microdermabrasion', 'Skin Consultation', 'Product Application',
      'Skin Care Routines', 'Facial Toning', 'Skin Hydration',
      'LED Treatments', 'Extraction Techniques', 'Facial Steaming',
      'Skin Rejuvenation', 'Dermal Fillers', 'Botox Administration',
      'Skin Tightening', 'Scar Treatment', 'Rosacea Treatment',
      'Pigmentation Treatment'
    ]
  },
  {
    name: 'Makeup Artistry',
    skills: [
      'Bridal Makeup', 'Special Effects Makeup', 'Fashion Makeup',
      'Airbrush Makeup', 'Editorial Makeup', 'Stage Makeup',
      'Color Theory', 'Contouring', 'Eye Makeup',
      'Lip Application', 'Foundation Matching', 'Makeup Consultation',
      'Product Knowledge', 'Makeup Hygiene', 'Corrective Makeup',
      'Period Makeup', 'Prosthetic Application', 'Body Painting',
      'Makeup for Photography', 'Makeup for Film', 'Makeup for TV',
      'Character Makeup', 'Avant-garde Makeup', 'Makeup Trends',
      'Natural Makeup'
    ]
  },
  {
    name: 'Nail Care',
    skills: [
      'Manicures', 'Pedicures', 'Nail Extensions',
      'Gel Application', 'Acrylic Application', 'Nail Art',
      'Hand Massage', 'Foot Massage', 'Nail Repair',
      'Cuticle Care', 'Polish Application', 'Nail Shapes',
      'Nail Health', 'Product Knowledge', 'Tool Sterilization',
      'French Manicure', 'Shellac Application', 'Nail Wraps',
      'Nail Assessment', 'Nail Diseases', 'Nail Disorders',
      'Paraffin Treatments', 'Nail Strengthening', 'Nail Design',
      'Color Theory'
    ]
  },
  {
    name: 'Body Treatments',
    skills: [
      'Body Massage', 'Body Wraps', 'Body Scrubs',
      'Aromatherapy', 'Hot Stone Therapy', 'Lymphatic Drainage',
      'Cellulite Treatments', 'Body Contouring', 'Spa Treatments',
      'Hydrotherapy', 'Reflexology', 'Swedish Massage',
      'Deep Tissue Massage', 'Sports Massage', 'Thai Massage',
      'Body Analysis', 'Treatment Planning', 'Product Application',
      'Body Consultation', 'Pressure Points', 'Body Assessment',
      'Relaxation Techniques', 'Energy Work', 'Body Detox',
      'Stress Relief'
    ]
  },
  {
    name: 'Hair Removal',
    skills: [
      'Waxing', 'Threading', 'Sugaring',
      'Laser Hair Removal', 'Electrolysis', 'IPL Treatment',
      'Eyebrow Shaping', 'Facial Hair Removal', 'Body Hair Removal',
      'Brazilian Waxing', 'Strip Waxing', 'Hot Waxing',
      'After Care', 'Hair Growth Cycles', 'Skin Reactions',
      'Contraindications', 'Product Knowledge', 'Tool Sterilization',
      'Client Consultation', 'Pain Management', 'Hair Assessment',
      'Treatment Planning', 'Hygiene Standards', 'Safety Protocols',
      'Client Comfort'
    ]
  },
  {
    name: 'Lash & Brow',
    skills: [
      'Lash Extensions', 'Lash Lifting', 'Lash Tinting',
      'Brow Lamination', 'Brow Tinting', 'Brow Shaping',
      'Microblading', 'Brow Mapping', 'Lash Removal',
      'Volume Lashes', 'Classic Lashes', 'Hybrid Lashes',
      'Brow Henna', 'Eye Analysis', 'Product Knowledge',
      'Tool Sterilization', 'Client Consultation', 'Aftercare Advice',
      'Color Selection', 'Shape Design', 'Application Techniques',
      'Safety Protocols', 'Hygiene Standards', 'Treatment Planning',
      'Style Customization'
    ]
  },
  {
    name: 'Beauty Business',
    skills: [
      'Client Relations', 'Appointment Booking', 'Retail Sales',
      'Inventory Management', 'Marketing Strategy', 'Social Media',
      'Business Planning', 'Financial Management', 'Team Leadership',
      'Customer Service', 'Product Knowledge', 'Salon Management',
      'Staff Training', 'Quality Control', 'Health & Safety',
      'Business Development', 'Client Retention', 'Service Pricing',
      'Promotional Planning', 'Brand Management', 'Time Management',
      'Record Keeping', 'Legal Compliance', 'Insurance Requirements',
      'Business Analytics'
    ]
  },
  {
    name: 'Advanced Treatments',
    skills: [
      'Micro-needling', 'Chemical Peels', 'Plasma Therapy',
      'Radio Frequency', 'Ultrasound Therapy', 'Cryotherapy',
      'Dermaplaning', 'Oxygen Therapy', 'LED Therapy',
      'Microcurrent', 'Collagen Induction', 'Skin Needling',
      'Advanced Facials', 'Medical Aesthetics', 'Treatment Combining',
      'Clinical Skincare', 'Advanced Products', 'Treatment Planning',
      'Client Assessment', 'Contraindications', 'Safety Protocols',
      'Emergency Response', 'Treatment Records', 'Results Monitoring',
      'Client Education'
    ]
  },
  {
    name: 'Product Knowledge',
    skills: [
      'Hair Products', 'Skincare Products', 'Makeup Products',
      'Nail Products', 'Treatment Products', 'Natural Products',
      'Product Chemistry', 'Product Safety', 'Product Application',
      'Product Selection', 'Product Storage', 'Product Ingredients',
      'Product Testing', 'Product Education', 'Product Recommendations',
      'Brand Knowledge', 'New Products', 'Product Trends',
      'Product Analysis', 'Product Performance', 'Product Allergies',
      'Product Interactions', 'Product Documentation', 'Product Training',
      'Product Marketing'
    ]
  },
  {
    name: 'Health & Safety',
    skills: [
      'Infection Control', 'Tool Sterilization', 'Workplace Safety',
      'First Aid', 'Hygiene Standards', 'Safety Protocols',
      'Risk Assessment', 'Emergency Procedures', 'Chemical Safety',
      'Equipment Safety', 'Client Safety', 'Personal Protection',
      'Waste Management', 'Safety Documentation', 'Safety Training',
      'Health Regulations', 'Safety Compliance', 'Accident Prevention',
      'Safety Monitoring', 'Safety Reporting', 'Safety Equipment',
      'Safety Maintenance', 'Safety Updates', 'Safety Assessment',
      'Safety Education'
    ]
  },
  {
    name: 'Client Care',
    skills: [
      'Consultation Skills', 'Client Assessment', 'Treatment Planning',
      'Client Communication', 'Aftercare Advice', 'Client Education',
      'Client Comfort', 'Client Privacy', 'Client Records',
      'Client Feedback', 'Client Relations', 'Client Retention',
      'Client Satisfaction', 'Client Support', 'Client Follow-up',
      'Special Needs Care', 'Client History', 'Client Preferences',
      'Client Scheduling', 'Client Updates', 'Client Concerns',
      'Client Solutions', 'Client Experience', 'Client Loyalty',
      'Client Development'
    ]
  }
];

// Export flattened list for backward compatibility
export const HAIR_BEAUTY_SKILLS = HAIR_BEAUTY_SKILLS_CATEGORIES.reduce(
  (acc, category) => [...acc, ...category.skills],
  [] as string[]
);
